import request from "@/utils/request.js"

export function getUserList(parm){
    return request.get("/wx",{
        params:parm
    })
}
export function getAllUser(parm){
    return request.get("/wx/all",{
        params:parm
    })
}
export function userAdd(parm){
    return request.post("/wx",{
        data:parm
    })
}
export function userUpdate(parm){
    return request.put("/wx",{
        data:parm
    })
}
export function userDelete(parm){
    return request.delete("/wx",{
        params:parm
    })
}